import Vue from "vue";
import VueSocialSharing from "vue-social-sharing";
Vue.use(VueSocialSharing, {
  networks: {
    instagram: "https://instagram.com/?url=https://www.drdrop.co/",
  },
});
Vue.use(VueSocialSharing);
